import React from 'react'
import { Icon } from './icon'
import './button.css'

/**
 * HTML Button
 */
export const Button = ({ label, icon, action, disabled = false, outlined, raised }) => {

    function click(event) {
        if (!disabled) {
            event.stopPropagation();
            event.preventDefault();
            if (action) action()
        }
    }

    let style = raised ? 'raised' : outlined ? 'outlined' : 'normal'
    if (disabled) style = `${style} disabled`
    return (
        <button className={`btn ${style}`} onClick={click}>
            { icon ? <Icon icon={icon} size="small" clickable action={click} /> : null }
            <span>{ label }</span>
        </button>
    )
}